// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"937":"4ec0217d","984":"4ffcf68f"}[chunkId] + ".chunk.js";
};